<template>
  <div class="CertificatType-main" :class="{ 'CertificatType-main-mobile': isMobile }">
    <CertificatTypeItem v-for="item in dataList" :key="item.id" :data="item"></CertificatTypeItem>
  </div>
</template>
<script>
  export default {
    name: 'CertificatType',
    data() {
      return {
        dataList: [
          {
            line1: '最高等级安全认证',
            line2: '手机操作系统',
            Icon: require('@/assets/images/homePage/grade-auth.png'),
            id: 1
          },
          {
            line1: '隐私信息管理体系认证',
            line2: '手机操作系统',
            Icon: require('@/assets/images/homePage/system-auth.png'),
            id: 2
          }
        ]
      };
    }
  };
</script>
<style lang="scss" scoped>
  .CertificatType-main {
    display: flex;
    margin-top: 0.95rem;
  }
  .CertificatType-main-mobile {
    margin-top: 2rem;
  }
</style>
